import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../api/api";
export default {
  getListKomplain: async ({ commit }, payload) => {
    try {
      const res = await conn.get(api.listKomplain, payload)
      if (res.data.code === 200) {
          if (res.data.data) {
            if (payload.offset > 0) {
              commit("updateListKomplain", res.data.data);
            }
            else {
              commit("setListKomplain", res.data.data);
            }
          }
        }
    } catch (e) {
      console.log(e);
      this.$toast.error(e)
    }
  },
  getDetailKomplain: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      conn
        .get(api.detail+payload)
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data) {
              commit("setDetailKomplain", res.data.data);
              resolve(res.data.data);
            }
          }
        })
        .catch((e) => {
          this.$toast.error(e)
          reject(e);
        });
    })
  },
  getListAkunRefund: ({ commit }, payload) => {
    conn
      .get(api.listAkunRefund + payload)
      .then((res) => {
        if (res.data.code === 200) {
          if (res.data.data) {
            commit("setListAkunRefund", res.data.data);
          }
        }
      })
      .catch((e) => {
        this.$toast.error(e)
      });
  },
  getRecomendedTransaksi: async ({ commit }, payload) => {
    try {
      commit("setListTransaksi", []);
      const res = await conn.get(api.listRecomendation + payload)
      if (res.data.code === 200) {
          commit("setListTransaksi", res.data.data);
          return resulter.successResult('sukses', res.data.data)
        }
    } catch (e) {
      return resulter.errorResult(e)
    }
  },
  searchSnapTransaksi: async ({ commit }, payload) => {
    try {
      const res = await conn.get(api.listSnapTransaction, payload)
      if (res.data.code === 200) {
        commit("setCount", res.data.count);
        if (res.data.data) {
          return resulter.successResult('sukses', res.data.data)
        }
        else {
          return resulter.successResult('sukses', [])
        }
      }
    } catch (e) {
      return resulter.errorResult(e)
    }
  },
  listSnapTransaksi: async ({ commit }, payload) => {
    try {
      const res = await conn.get(api.listSnapTransaction, payload)
      if (res.data.code === 200) {
          commit("addListTransaksiSnap", res.data);
          return resulter.successResult('sukses', res.data.data)
        }
    } catch (e) {
      return resulter.errorResult(e)
    }
  }
};
